import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SESSION_TOKEN_STORAGE_KEY } from '@app/auth/auth-storage.constants';

@Injectable({
    providedIn: 'root'
})
export class SessionInterceptorService implements HttpInterceptor {


    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const xAuthToken = localStorage.getItem(SESSION_TOKEN_STORAGE_KEY);

        let request = req;

        if (xAuthToken) {
            request = req.clone({
                setHeaders: {
                    'X-Olimpo-Sessiontoken': xAuthToken
                }
            });
        }

        return next.handle(request).pipe(
            tap(event => {
                if (event instanceof HttpResponse) {
                    const xAuthTokenOnResponse = event.headers.get(SESSION_TOKEN_STORAGE_KEY);
                    if (xAuthTokenOnResponse) {
                        localStorage.setItem(SESSION_TOKEN_STORAGE_KEY, xAuthTokenOnResponse)
                    }
                }
            })
        );
    }
}
